import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import api from 'lib/trpcClient';
import ExpensesDetails from './ExpensesDetails';
import InvestmentsDetails from './InvestmentsDetails';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useParams } from 'react-router-dom';
import FeeDetails from './FeeDetails';
import useSyncActionsValues from '../hooks/useSyncActionsValues';
import EqualisationsDetails from '../EqualisationsDetails';

type Props = {
  vehicleId: string;
  entryType: CapitalActionEntryType;
  actions: Array<{ id: string }>;
  entryIndex: number;
};

const ActionsDetails: React.FC<Props> = ({
  vehicleId,
  entryType,
  actions,
  entryIndex,
}) => {
  const { id } = useParams<{ id?: string }>();
  const { vehicle } = useVehicle(vehicleId);

  const [actionsDetails] = api.capitalAction.getActionsDetails.useSuspenseQuery(
    {
      capitalActionId: id,
      vehicleId,
      entryType,
      actionIds: actions.map((action) => action.id),
    },
  );

  useSyncActionsValues({
    actions: actionsDetails?.actions ?? [],
    entryIndex,
  });

  if (!actions.length) {
    return null;
  }

  return (
    <>
      {actionsDetails?.entryType === CapitalActionEntryType.Expense && (
        <ExpensesDetails
          expenses={actionsDetails.actions}
          baseCurrency={vehicle?.baseCurrency ?? CurrencyCode.GBP}
          vehicleId={vehicleId}
          entryIndex={entryIndex}
        />
      )}
      {actionsDetails?.entryType === CapitalActionEntryType.Investment && (
        <InvestmentsDetails
          investments={actionsDetails.actions}
          baseCurrency={vehicle?.baseCurrency ?? CurrencyCode.GBP}
          vehicleId={vehicleId}
          entryIndex={entryIndex}
        />
      )}
      {actionsDetails?.entryType === CapitalActionEntryType.Fees && (
        <FeeDetails
          feeActions={actionsDetails.actions}
          baseCurrency={vehicle?.baseCurrency ?? CurrencyCode.GBP}
        />
      )}
      {actionsDetails?.entryType === CapitalActionEntryType.Equalisation && (
        <EqualisationsDetails
          equalisations={actionsDetails.actions}
          baseCurrency={vehicle?.baseCurrency ?? CurrencyCode.GBP}
        />
      )}
    </>
  );
};

export default ActionsDetails;
